import { MapPin } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { ReturnStoreAddressEditorRenderer } from "./editor";
import { ReturnStoreAddressEmailRenderer } from "./email";
import type { ReturnStoreAddressBlockProps } from "./types";

export default registerBlock<ReturnStoreAddressBlockProps>({
  type: "return-store-address",
  name: "editorBlocksLibrary.blocks.return-store-address.title",
  description: "editorBlocksLibrary.blocks.return-store-address.description",
  Icon: MapPin,
  category: BlockCategory.RETURN,
  hasDynamicContent: true,
  components: {
    email: {
      component: ReturnStoreAddressEmailRenderer,
      editor: {
        component: ReturnStoreAddressEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
      },
      compatibility: {
        rowBlock: false,
      },
    },
  },
});

export type { ReturnStoreAddressBlockProps } from "./types";
